<script setup lang="ts">
import type { IColumnDefinition, RowData } from '../types';

defineProps<{ value: any; row: RowData; column: IColumnDefinition }>();
</script>

<template>
  <span class="itp-template-formatter">
    <slot name="default">{{ value }}</slot>
  </span>
</template>
